export default class topManager {
    constructor() {

    }
    init(){

        let _this = this;

    }

    render(mouse){

        //this.renderer.render(this.stage);

    }
    resize(_w,_h,_display){

        let _this = this;

    }

    modal(type){

    }

}